if (window.PUBLIC_PATH) {
    /* global __webpack_public_path__:writable */
    /* exported __webpack_public_path__ */

    __webpack_public_path__ = window.PUBLIC_PATH;
    
    console.log('PUBLIC_PATH found for override')
}